import { jsx } from 'react/jsx-runtime';
import { createSvgIcon } from '@mui/material/utils';

const PortalsIcon = createSvgIcon(jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4,8.5H8.5V4H4ZM10.75,22h4.5V17.5h-4.5ZM4,22H8.5V17.5H4Zm0-6.75H8.5v-4.5H4Zm6.75,0h4.5v-4.5h-4.5ZM17.5,4V8.5H22V4ZM10.75,8.5h4.5V4h-4.5Zm6.75,6.75H22v-4.5H17.5Zm0,6.75H22V17.5H17.5Z", transform: "translate(-4 -4)" }) })), 'PortalsIcon');

export { PortalsIcon };
